import {Component, inject} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {PreloaderService, SettingsService} from "./core";

@Component({
  selector: 'app-main',
  template: '<router-outlet></router-outlet>',
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent {

  private readonly preloader = inject(PreloaderService);
  private readonly settings = inject(SettingsService);

  ngOnInit() {
    this.settings.setDirection();
    this.settings.setTheme();
  }

  ngAfterViewInit() {
    this.preloader.hide();
  }

}
